import { GzWidgetProductItemWebComponent } from './component/GzWidgetProductItemWebComponent';

export { GzWidgetProductItemWebComponent };
